import { create } from "zustand";

export type ExamView = "original" | "digitized";

// Exam preview UI state:
//  * activeTaskId — which Exam task is active (clicked) in the Exam panel; drives
//    the highlight over the relevant section in the rendered Exam PDF.
//  * examView — whether the center preview shows the uploaded original or the
//    digitized (OCR'd) copy of a scanned exam. The folded-corner toggle in the
//    preview header switches it; resets to "original" when the selection changes.
interface ExamUiState {
  activeTaskId: number | null;
  setActiveTaskId: (id: number | null) => void;
  examView: ExamView;
  setExamView: (view: ExamView) => void;
}

export const useExamUiStore = create<ExamUiState>((set) => ({
  activeTaskId: null,
  setActiveTaskId: (id) => set({ activeTaskId: id }),
  examView: "original",
  setExamView: (view) => set({ examView: view }),
}));
